import React, { Component } from 'react'
import { graphql } from 'gatsby'
import Link from '../utils/link'
//import he from 'he'
import Fade from 'react-reveal/Fade'
import moment from 'moment';
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import AddToCalendar from 'react-add-to-calendar'
import Lightbox from 'react-image-lightbox'

import SEO from '../components/seo'
import Map from '../components/map'
import Video from '../components/video'

import { Play } from '../components/icons'

// Component to fix beforeChange bug rerendering slick
class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }  
  render() {
    return (<>{ this.props.children }</>)
  }
}

class PropertyPage extends Component {

  state = {
    show: false,
    photoIndex: 0,
    isOpen: false,
    activeSlide: 0,
    floorplan_lightbox: false,
    floorplanSlideIndex: 0,
    gallery_lightbox: false,
  }

  showModal = () => {
    this.setState({ show: true })
    let src = document.querySelector('.video-wrapper iframe').getAttribute('src')
    src += '?autoplay=1'
    document.querySelector('.video-wrapper iframe').setAttribute('src', src)
  }

  hideModal = () => {
    this.setState({ show: false })
    let src = document.querySelector('.video-wrapper iframe').getAttribute('src')
    let stopVideoSrc = src.replace('?autoplay=1', '')
    document.querySelector('.video-wrapper iframe').setAttribute('src', stopVideoSrc)
  }

  renderText = (el, i) => {
    if (el.length === 0) return
    if (el.length < 25 && el.indexOf('•') === -1) return <h4 key={i}>{ el }</h4>
    if (el.indexOf('•') !== -1) return <li key={i}>{ el.replace(/•/gi, '') }</li>
    return <p key={i}>{ el }</p>
  }

  _renderFloorplanLightbox(images) {
    let { floorplanSlideIndex } = this.state
    let active = this.state.floorplan_lightbox

    if (active) {
      return (
        <Lightbox
          mainSrc={images[floorplanSlideIndex]}
          nextSrc={images[(floorplanSlideIndex + 1) % images.length]}
          prevSrc={images[(floorplanSlideIndex + images.length - 1) % images.length]}
          enableZoom={false}
          onCloseRequest={() => this.setState({ floorplan_lightbox: false })}
          onMovePrevRequest={() =>
            this.setState({
              floorplanSlideIndex: (floorplanSlideIndex + images.length - 1) % images.length,
            })
          }
          onMoveNextRequest={() =>
            this.setState({
              floorplanSlideIndex: (floorplanSlideIndex + 1) % images.length,
            })
          }
        />
      )
    }

    return null
  }

  _renderGalleryLightbox(images, lightboxIndex) {

    return (
      <Lightbox
        mainSrc={images[lightboxIndex]}
        nextSrc={images[(lightboxIndex + 1) % images.length]}
        prevSrc={images[(lightboxIndex + images.length - 1) % images.length]}
        enableZoom={false}
        onCloseRequest={() => {
          this.setState({ gallery_lightbox: false })
        }}
        onMovePrevRequest={() =>
          this.setState({
            lightboxIndex: (lightboxIndex + images.length - 1) % images.length,
          })
        }
        onMoveNextRequest={() =>
          this.setState({
            lightboxIndex: (lightboxIndex + 1) % images.length,
          })
        }
      />
    )
  }

  render() {

    let page = this.props.data.wpProperty
    let team = this.props.data.allWpTeamMember

    const { propertyData, propertyMeta, propertyImages, propertyInspections, propertyContent } = page

    const { gallery_lightbox, lightboxIndex } = this.state;

    let gallery = propertyImages.sort((a, b) => {
      if (a.index === 'MAIN') return -1
      if (b.index === 'MAIN') return 1
      if (a.index.indexOf('FLOORPLAN') !== -1) return 1
      if (b.index.indexOf('FLOORPLAN') !== -1) return -1
      return a.index > b.index ? 1 : -1
    })

    const floorplan = gallery.filter(el => el.index.indexOf('FLOORPLAN') !== -1).map(el => el.url)
    gallery = gallery.filter(el => el.index.indexOf('FLOORPLAN') === -1)
    const images = gallery.map(el => el.media ? el.media.url : el.url)
    if (propertyData.video_link_url) gallery.splice(3, 0, 'video')

    let inspections = []

    let locationString = propertyMeta.number+' '+propertyMeta.street_name+' '+propertyMeta.street_type+', '+propertyMeta.suburb

    if (propertyData.address_undisclosed) locationString = propertyMeta.suburb

    if (propertyInspections) {
      inspections = propertyInspections.map((el, i) => {
        if (!el.inspection_date || moment(el.inspection_date).add(1, 'days').isBefore(new Date())) return null
        let event = {
          title: 'Property Inspection',
          description: '',
          location: locationString,
          startTime: moment(el.inspection_date + ' ' + el.start_time),
          endTime: moment(el.inspection_date + ' ' + el.end_time)
        }
        return (
          <li key={i}>
            <AddToCalendar event={event} buttonLabel={moment(el.inspection_date).format('dddd DD MMM YYYY, ') +' '+moment(el.inspection_date + ' ' + el.start_time).format('LT - ')+moment(el.inspection_date + ' ' + el.end_time).format('LT') } />
          </li>
        )
      }).filter(el => el !== null)
    }

    let auction = null
    if (propertyData.auction_date) {
      let text = moment(propertyData.auction_date).format('dddd DD MMM YYYY, ') + moment(propertyData.auction_date + ' ' + propertyData.auction_time).format('LT')
      let event = {
        title: 'Property Auction',
        description: '',
        location: locationString,
        startTime: moment(propertyData.auction_date + ' ' + propertyData.auction_time),
        endTime: moment(propertyData.auction_date + ' ' + propertyData.auction_time).add(1, 'hours')
      }
      auction = <AddToCalendar event={event} buttonLabel={text} />
    }

    let staff = propertyData.consultant_ids.map((el, i) => {
      return team.edges.find(t => parseInt(t.node.boxId) === el)
    }).filter(el => el).slice(0, 2)

    let cars = propertyMeta.cars ? propertyMeta.cars : 0
    cars = propertyMeta.garages + cars

    return (
      <>
        <SEO title={locationString} bodyClass={'property-single'} description={page.seo.metaDesc} />
        <article className='single-property'>
          { propertyImages.length > 0 &&
            <section className='single-property__gallery'>
              <div className='single-property__gallery-inner'>
                <img src={propertyImages[0].url} alt={locationString} />
                { propertyData.video_link_url && <div className='single-property__gallery-play-wrap'><div className='single-property__gallery-play' onClick={() => window.scroll({ top: document.querySelector('.video').getBoundingClientRect().top, left: 0, behavior: 'smooth'})}><Play color='#ffffff' /></div></div> }
              </div>
            </section>
          }
          <section className="single-property__information">
            <div className='single-property__inner'>
              <div className='single-property__header'>
                <Fade bottom distance="30px">
                  <>
                    { !propertyData.address_undisclosed && 
                      <h1>{ propertyMeta.unit ? propertyMeta.unit+'/' : '' }{ propertyMeta.number } { propertyMeta.street_name } { propertyMeta.street_type }, { propertyMeta.suburb }</h1>
                    }
                    { propertyData.address_undisclosed && 
                      <h1>{ propertyMeta.suburb }</h1>
                    }
                    <ul className='single-property__features'>
                      <li><span className='single-property__line' /></li>
                      <li><span>{ propertyMeta.beds } Bed</span></li>
                      <li><span>{ propertyMeta.baths } Bath</span></li>
                      { cars > 0 &&
                        <li><span>{cars} Car</span></li>
                      }
                    </ul>
                    <div className='single-property--desktop'>
                      { propertyData.website_status === 'current' && propertyInspections[0].inspection_date &&
                        <div className='single-property__inspections'>
                          <span>Inspection</span>
                          <ul>
                            { inspections }
                          </ul>
                        </div>
                      }
                      <div className='single-property__agents'>
                        { staff && staff.map((el, i) => (
                            <div className='single-property__agent' key={i}>
                              <picture className='single-property__agent-image'>
                              { el.node.teamData.staff_image_url &&
                                <img src={el.node.teamData.staff_image_url} alt={el.node.teamData.first_name} />
                              }
                              </picture>
                              <div className='single-property__agent-content'>
                                <h5>{ el.node.teamData.first_name } { el.node.teamData.last_name }</h5>
                                { el.node.teamData.mobile && <p className='hoverline'><Link to={`tel:${ el.node.teamData.mobile }`}>{ parsePhoneNumberFromString(el.node.teamData.mobile, 'AU').formatNational() }</Link> - <Link to={`mailto:${el.node.teamData.email}`}>Email</Link></p> }
                              </div>
                            </div>
                          ))}
                      </div>
                      <ul className='single-property__links'>
                        { propertyData.status.toUpperCase() !== 'NOT_SETTLED' && propertyData.website_status.toUpperCase() !== 'SOLD' && floorplan.length > 0 &&
                          <li>
                            <span onClick={() => this.setState({floorplan_lightbox: true})}>
                              View Floor Plan
                            </span>
                          </li>
                        }
                        { propertyData.soi_file && propertyData.status.toUpperCase() !== 'NOT_SETTLED' && propertyData.website_status.toUpperCase() !== 'SOLD' &&
                          <li><Link to={propertyData.soi_file} target='_blank' rel='noopener noreferrer'>Statement of Information</Link></li>
                        }
                      </ul>
                    </div>
                  </>
                </Fade>
              </div>
              <div className='single-property__body'>
                <Fade bottom distance='30px'>
                  <div className='single-property__content'>
                    { propertyContent && propertyContent.heading && <h2>{propertyContent.heading}</h2> }
                    <p className={ propertyData.website_status === 'SOLD' || propertyData.status !== 'NOT_SETTLED' ? 'status sold' : 'status' }>
                      { propertyData.website_status === 'sold' ? 'Sold' + (!propertyData.price_undisclosed ? ' - ' : '') : '' }
                      { propertyData.status === 'NOT_SETTLED' && propertyData.website_status === 'current' && propertyData.under_offer === true ? 'Contracted - ' : '' }
                      { !propertyData.price_undisclosed ? (
                        propertyData.website_status === 'sold' ? '$'+parseFloat(propertyData.sale_price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace(/\.00/, '') : propertyData.display_price 
                      ) : (
                        propertyData.website_status !== 'sold' ? 'Contact Agent' : ''
                      ) }
                    </p>
                    { propertyContent && propertyContent.text && propertyContent.text.split('\n').map(this.renderText) }
                  </div>
                  <div className='single-property--mobile'>
                    { propertyData.website_status === 'current' && propertyInspections[0].inspection_date &&
                      <div className='single-property__inspections'>
                        <span>Inspection</span>
                        <ul>
                          { inspections }
                        </ul>
                      </div>
                    }
                    <div className='single-property__agents'>
                      { staff && staff.map((el, i) => (
                          <div className='single-property__agent' key={i}>
                            <picture className='single-property__agent-image'>
                            { el.node.teamData.staff_image_url &&
                              <img src={el.node.teamData.staff_image_url} alt={el.node.teamData.first_name} />
                            }
                            </picture>
                            <div className='single-property__agent-content'>
                              <h5>{ el.node.teamData.first_name } { el.node.teamData.last_name }</h5>
                              { el.node.teamData.mobile && <p className='hoverline'><Link to={`tel:${ el.node.teamData.mobile }`}>{ parsePhoneNumberFromString(el.node.teamData.mobile, 'AU').formatNational() }</Link> - <Link to={`mailto:${el.node.teamData.email}`}>Email</Link></p> }
                            </div>
                          </div>
                        ))}
                    </div>
                    <ul className='single-property__links'>
                      { propertyData.status.toUpperCase() !== 'NOT_SETTLED' && propertyData.website_status.toUpperCase() !== 'SOLD' && floorplan.length > 0 &&
                        <li>
                          <span onClick={() => this.setState({floorplan_lightbox: true})}>
                            View Floor Plan
                          </span>
                        </li>
                      }
                      { propertyData.soi_file && propertyData.status.toUpperCase() !== 'NOT_SETTLED' && propertyData.website_status.toUpperCase() !== 'SOLD' &&
                        <li><Link to={propertyData.soi_file} target='_blank' rel='noopener noreferrer'>Statement of Information</Link></li>
                      }
                    </ul>
                  </div>
                </Fade>
              </div>
              <div className='single-property__footer'>
                <div className='single-property__map'>
                  { propertyMeta.latitude && propertyMeta.latitude &&
                    <BlockUpdate>
                      <Map lat={propertyMeta.latitude.toString()} lng={propertyMeta.longitude.toString()} />
                    </BlockUpdate>
                  }
                </div>
              </div>
            </div>
          </section>
          { gallery &&
            <section className='single-property__images'>
              {gallery.map((el, i) => {
                let onClick = () => {
                  this.setState({ gallery_lightbox: true, lightboxIndex: i })
                }
                if (el === 'video') {
                  return (
                    <Video key={i} videoUrl={propertyData.video_link_url} />
                  )
                } else {
                  return (
                    <div className='single-property__image-row' key={i}>
                      <Fade bottom distance='30px'>
                        <div className='single-property__image' onClick={onClick}>
                          <img src={el.url} alt={locationString} />
                        </div>
                      </Fade>
                    </div>
                  )
                }

              })}
            </section>
          }
          { gallery_lightbox && this._renderGalleryLightbox(images, lightboxIndex) }
          { (floorplan.length > 0 || propertyData.interactive_floor_plan_url) && this._renderFloorplanLightbox(floorplan) }
        </article>
      </>
    )
  }
}

export default PropertyPage

export const propQuery = graphql`
  query ($id: String!) {
    wpProperty(id: {eq: $id}) {
      id
      databaseId
      title
      slug
      seo {
        title
        metaDesc
      }
      propertyData {
        office_id
        status
        primary_consultant_id
        consultant_ids
        listing_type
        hidden
        price_undisclosed
        address_undisclosed
        suburb_undisclosed
        under_offer
        website_status
        auction
        price_from
        price_to
        display_price
        situation_very_sensitive
        date_listed
        campaign_start_date
        sale_price
        video_link_url
        virtual_tour_url
        interactive_floor_plan_url
        soi_file
      }
      propertyInspections {
        inspection_date
        start_time
        end_time
      }
      propertyContent {
        heading
        text
      }
      propertyImages {
        index
        url
      }
      propertyMeta {
        unit
        number
        street_name
        street_type
        suburb
        postcode
        state
        country
        latitude
        longitude
        beds
        baths
        garages
        cars
        property_styles
      }
    }
    allWpTeamMember {
      edges {
        node {
          id
          databaseId
          slug
          title
          boxId
          teamData {
            office_id
            first_name
            last_name
            avatar_url
            staff_image_url
            mobile
            email
          }
          acf {
            content
            video
            linkedin
            facebook
            instagram
            twitter
            profileImage {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
